<div class="auth-container">

  <div class="auth-card">

    <h2 class="auth-title">Reiniciar contraseña</h2>

    <p class="auth-subtitle">
      Te enviaremos un email con un link para crear una nueva contraseña.
    </p>

    <form (ngSubmit)="onSubmit(f.form)" #f="ngForm" novalidate>

      <div class="form-group">
        <label>Email</label>
        <input
          type="email"
          class="form-control"
          name="email"
          [(ngModel)]="email"
          #emailInput="ngModel"
          [class.is-invalid]="f.submitted && emailInput.invalid"
          required email
        >

        <div class="invalid-feedback">
          Ingresá un email válido.
        </div>
      </div>

      <button type="submit" class="btn btn-success btn-block btn-lg mt-3">
        Enviar instrucciones
      </button>

    </form>

  </div>

</div>